import { instanceNameOf, isHidden, valueOrNull } from "@/shared/value";
import { CompanyDocumentTreeNode } from "../model/types";
import { isFolderNode } from "./tree-node-guards";

/**
 * Скрытый узел получает имя от защиты, а если та его не отдала — подпись «скрыто»:
 * иначе в дереве остаётся пустая, но кликабельная и перетаскиваемая строка. Проверку
 * на скрытость делаем первой: `?? instanceNameOf(...)` путал её с видимой папкой,
 * у которой просто пустое название.
 */
export function nodeTitle(
  node: CompanyDocumentTreeNode,
  hiddenLabel: string,
): string {
  if (isFolderNode(node)) {
    if (isHidden(node.folder)) {
      return instanceNameOf(node.folder) || hiddenLabel;
    }

    return valueOrNull(node.folder)?.name.value ?? "";
  }

  if (isHidden(node.document)) {
    return instanceNameOf(node.document) || hiddenLabel;
  }

  const document = valueOrNull(node.document);

  return document?.name.value ?? document?.file.fileName ?? "";
}
